let namePrefix = 'portal-cpanel'
const routes =  [
  {
    path: '/cpanel',
    name: namePrefix,
    parent: '/',
    component: () => import('@/app/portals/cpanel/Main.vue'),
    redirect: {
      name: namePrefix + '-dashboard'
    },
    children: [
      {
        path: 'dashboard',
        name: namePrefix + '-dashboard',
        component: () => import('@/app/portals/cpanel/pages/Dashboard.vue'),
        meta: {
          guards: {
            'auth': {}
          }
        },
      }
    ]
  }
]

export default routes
